module.exports = __webpack_public_path__ + "static/main-3389985618fbdcce0604c9678770160a.jpg";